/* Include Javascript executed the first thing inside the body element */

const agentIdMaxValue = 10000000000;
const gemIdMaxLength = 20; // chars
const gemId3MaxLength = 255; // chars
const productIdMaxValue = 10000000000;
const productMaxValue = 255; // chars;

const affiliateCookieName = "affiliate_params";

const affiliateCookieAttrNameAgentId = "AgentID";
const affiliateCookieAttrNameGemId1 = "gemid1";
const affiliateCookieAttrNameGemId2 = "gemid2";
const affiliateCookieAttrNameGemId3 = "gemid3";
const affiliateCookieAttrNameProductId = "productTypeId";
const affiliateCookieAttrNameProduct = "product";

const requestParamNameAgentId = "AgentID";
const requestParamNameAgentIdLowerCase = "agentid";
const requestParamNameGemId1 = "gemid1";
const requestParamNameGemId2 = "gemid2";
const requestParamNameGemId3 = "gemid3";
const requestParamNameProduct = "producttype";

const utmCookieName = "utm_params";

const requestParamUtmSource = "utm_source";
const requestParamUtmMedium = "utm_medium";
const requestParamUtmCampaing = "utm_campaign";
const requestParamUtmTerm = "utm_term";
const requestParamUtmContent = "utm_content";
const requestParamCreative = "creative";

const getAffiliateProduct = () => window.affiliateProduct;

const createAffiliateCookieObject = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const object = {};
  if (urlParams.has(requestParamNameAgentId)) {
    const agentIdNumber = Number.parseInt(
      urlParams.get(requestParamNameAgentId),
      10,
    );
    if (agentIdNumber <= agentIdMaxValue) {
      object[affiliateCookieAttrNameAgentId] = agentIdNumber;
    }
  }
  if (urlParams.has(requestParamNameGemId1)) {
    const gemId1 = urlParams.get(requestParamNameGemId1);
    if (gemId1.length <= gemIdMaxLength) {
      object[affiliateCookieAttrNameGemId1] = gemId1;
    }
  }
  if (urlParams.has(requestParamNameGemId2)) {
    const gemId2 = urlParams.get(requestParamNameGemId2);
    if (gemId2.length <= gemIdMaxLength) {
      object[affiliateCookieAttrNameGemId2] = gemId2;
    }
  }
  if (urlParams.has(requestParamNameGemId3)) {
    const gemId3 = urlParams.get(requestParamNameGemId3);
    if (gemId3.length <= gemId3MaxLength) {
      object[affiliateCookieAttrNameGemId3] = gemId3;
    }
  }
  if (urlParams.has(requestParamNameProduct)) {
    const product = Number.parseInt(urlParams.get(requestParamNameProduct), 10);
    if (product <= productIdMaxValue) {
      object[affiliateCookieAttrNameProductId] = product;
    }
  }

  const product = getAffiliateProduct();
  if (product !== undefined && product.length <= productMaxValue) {
    object[affiliateCookieAttrNameProduct] = product;
  }

  return object;
};

const createUtmCookieObject = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const object = {};
  if (urlParams.has(requestParamUtmSource)) {
    object[requestParamUtmSource] = urlParams.get(requestParamUtmSource);
  }
  if (urlParams.has(requestParamUtmMedium)) {
    object[requestParamUtmMedium] = urlParams.get(requestParamUtmMedium);
  }
  if (urlParams.has(requestParamUtmCampaing)) {
    object[requestParamUtmCampaing] = urlParams.get(requestParamUtmCampaing);
  }
  if (urlParams.has(requestParamUtmTerm)) {
    object[requestParamUtmTerm] = urlParams.get(requestParamUtmTerm);
  }
  if (urlParams.has(requestParamUtmContent)) {
    object[requestParamUtmContent] = urlParams.get(requestParamUtmContent);
  }
  if (urlParams.has(requestParamCreative)) {
    object[requestParamCreative] = urlParams.get(requestParamCreative);
  }

  if (urlParams.has(requestParamNameAgentId)) {
    object[requestParamNameAgentId] = urlParams.get(requestParamNameAgentId);
  }
  if (urlParams.has(requestParamNameAgentIdLowerCase)) {
    object[requestParamNameAgentId] = urlParams.get(
      requestParamNameAgentIdLowerCase,
    );
  }
  if (urlParams.has(requestParamNameGemId1)) {
    object[affiliateCookieAttrNameGemId1] = urlParams.get(
      requestParamNameGemId1,
    );
  }

  return object;
};

const cookiePath = "/";

const getDomainWithDot = () => {
  let hostname = window.location.hostname;
  hostname = hostname.split(".");
  hostname = hostname.slice(Math.max(0, hostname.length - 2));
  hostname = hostname.join(".");

  return `.${hostname}`;
};

const affiliateCookieService = () => {
  if (window.isCookieOneTrustActiveGroupMarketingEnabled()) {
    const affiliateCookieObject = createAffiliateCookieObject();
    const nowDate = new Date();
    const expiresDate = new Date(nowDate.setDate(nowDate.getDate() + 10));
    const value = `"${JSON.stringify(affiliateCookieObject).replace(
      /"/g,
      '\\"',
    )}"`;

    if (Object.keys(affiliateCookieObject).length > 0) {
      document.cookie = `${affiliateCookieName}=${value}; expires=${expiresDate.toUTCString()}; path=${cookiePath}; domain=${getDomainWithDot()}`;
    }
  }
};

const utmCookieService = () => {
  if (window.isCookieOneTrustActiveGroupMarketingEnabled()) {
    const utmCookieObject = createUtmCookieObject();
    const expiresDate = new Date();
    expiresDate.setHours(23);
    expiresDate.setMinutes(59);
    expiresDate.setSeconds(59);
    const value = `"${JSON.stringify(utmCookieObject).replace(/"/g, '\\"')}"`;

    if (Object.keys(utmCookieObject).length > 0) {
      document.cookie = `${utmCookieName}=${value}; expires=${expiresDate.toUTCString()}; path=${cookiePath}; domain=${getDomainWithDot()}`;
    }
  }
};

// every request
affiliateCookieService();
utmCookieService();

const affiliateCookieOneTrustOnConsentChanged = () => {
  if (
    window.Optanon !== undefined &&
    window.Optanon.OnConsentChanged !== undefined
  ) {
    window.Optanon.OnConsentChanged(affiliateCookieService);
  }
};

const utmCookieOneTrustOnConsentChanged = () => {
  if (
    window.Optanon !== undefined &&
    window.Optanon.OnConsentChanged !== undefined
  ) {
    window.Optanon.OnConsentChanged(utmCookieService);
  }
};

// if cookie preference changed
window.affiliateCookieOneTrustOnConsentChanged =
  affiliateCookieOneTrustOnConsentChanged;
window.utmCookieOneTrustOnConsentChanged = utmCookieOneTrustOnConsentChanged;

const liferayCookieConsentNecessaryName = "CONSENT_TYPE_NECESSARY";
const liferayCookieConsentFunctionalName = "CONSENT_TYPE_FUNCTIONAL";
const liferayCookieConsentPerformanceName = "CONSENT_TYPE_PERFORMANCE";
const liferayCookieConsentPersonalizationName = "CONSENT_TYPE_PERSONALIZATION";
const liferayCookieConfiguredName = "USER_CONSENT_CONFIGURED";

// place for custom scripts
const oneTrustActiveGroupsChanged = () => {
  const expiresDate = new Date();
  expiresDate.setFullYear(expiresDate.getFullYear() + 1);

  const marketingEnabled = window.isCookieOneTrustActiveGroupMarketingEnabled();
  const functionalityEnabled =
    window.isCookieOneTrustActiveGroupFunctionalityEnabled();
  const analyticsEnabled = window.isCookieOneTrustActiveGroupAnalyticsEnabled();

  // liferay fix: liferay does not automatically delete these cookies
  if (!analyticsEnabled || !marketingEnabled || !functionalityEnabled) {
    document.cookie =
      "ac_client_user_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie.split(";").forEach((cookie) => {
      const [cookieName] = cookie.split("=");
      if (/^ab_test_variant_id_.+/.test(cookieName.trim())) {
        document.cookie = `${cookieName.trim()}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      }
    });
  }

  if (marketingEnabled && functionalityEnabled && analyticsEnabled) {
    document
      .getElementById(
        "_com_liferay_cookies_banner_web_portlet_CookiesBannerPortlet_acceptAllButton",
      )
      .click();
    return;
  }
  if (!marketingEnabled && !functionalityEnabled && !analyticsEnabled) {
    document
      .getElementById(
        "_com_liferay_cookies_banner_web_portlet_CookiesBannerPortlet_declineAllButton",
      )
      .click();
    return;
  }

  document.cookie = `${liferayCookieConsentNecessaryName}=${true}; expires=${expiresDate.toUTCString()}; path=${cookiePath}`;
  document.cookie = `${liferayCookieConfiguredName}=${true}; expires=${expiresDate.toUTCString()}; path=${cookiePath}`;

  document.cookie = `${liferayCookieConsentFunctionalName}=${functionalityEnabled}; expires=${expiresDate.toUTCString()}; path=${cookiePath}`;
  document.cookie = `${liferayCookieConsentPerformanceName}=${analyticsEnabled}; expires=${expiresDate.toUTCString()}; path=${cookiePath}`;
  document.cookie = `${liferayCookieConsentPersonalizationName}=${marketingEnabled}; expires=${expiresDate.toUTCString()}; path=${cookiePath}`;
};

window.oneTrustActiveGroupsChanged = oneTrustActiveGroupsChanged;
